export const NEW_PORTAL_FORM = "marketplaceNewAutomationForm";